// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Title bar layout ──────────────────────────────────────── */
.fpt-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 1rem;
  margin-top: 0.5rem;
}

.fpt-left {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
}

.fpt-title {
  font-size: 1.25rem;
  font-weight: 600;
  margin: 0;
}

.fpt-status-label {
  color: var(--bs-secondary-color, #6c757d);
}

/* ── Badge cluster ─────────────────────────────────────────── */
.fpt-badges {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
}

.fpt-badge-success {
  background-color: transparent;
  color: var(--bs-success);
  border: 1px solid var(--bs-success);
  font-size: 0.7rem;
  padding: 2px 7px;
  border-radius: 20px;
}

.fpt-badge-warning {
  background-color: transparent;
  color: var(--bs-warning);
  border: 1px solid var(--bs-warning);
  font-size: 0.7rem;
  padding: 2px 7px;
  border-radius: 20px;
}

.fpt-badge-info {
  background-color: transparent;
  color: var(--bs-info);
  border: 1px solid var(--bs-info);
  font-size: 0.7rem;
  padding: 2px 7px;
  border-radius: 20px;
}

.fpt-badge-primary {
  background-color: transparent;
  color: var(--bs-primary);
  border: 1px solid var(--bs-primary);
  font-size: 0.7rem;
  padding: 2px 7px;
  border-radius: 20px;
}
`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
